
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aviso-de-privacidad",
      function () {
        return require("private-next-pages/aviso-de-privacidad/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aviso-de-privacidad"])
      });
    }
  